import styled from 'styled-components';
import { palette } from 'styles/colors';
import { layout } from 'styles/layout';

export const MightyHostsBannerWrapper = styled.div`
  width: 100%;
  max-width: 992px !important; // needed to override the default layout max-width
  margin: 0 auto 60px;
  color: ${palette.white};
  padding: 24px;
  text-align: center;
  background: linear-gradient(95.79deg, ${palette.snowFlower} 17.08%, ${palette.purple} 81.93%);
  box-sizing: border-box;

  @media screen and (min-width: ${layout.subMd}) {
    padding: 64px 250px;
  }

  > h3,
  > p {
    margin-bottom: 18px;
  }

  > a {
    min-width: 256px;
    background-color: ${palette.white};
    color: ${palette.snowFlower};
    font-weight: 500;
    margin-top: 50px;
  }
`;
